import template from './privilege-template-form.html';

const mapStateToThis = ({ config, ui }) => {
  const { selectedLanguage } = ui;
  const { locales } = config;

  return {
    locales,
    selectedLanguage,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class PrivilegeTemplateFormController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  submit() {
    this.form.$setSubmitted();

    if (this.form.$valid) {
      this.close({ $value: this.translations });
    }
  }
}

export default class PrivilegeTemplateFormComponent {
  constructor() {
    this.controller = PrivilegeTemplateFormController;
    this.template = template;
    this.bindings = {
      close: '&',
      resolve: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/components/privilege-template-form/privilege-template-form-component.js